import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import AuthPage from './AuthPage';
import ProfileHeader from '../components/profile/ProfileHeader';
import ProfileForm from '../components/profile/ProfileForm';

type Props = {
  onNavigate?: (page: 'home' | 'favorites' | 'profile' | 'diet-admin' | 'admin-panel') => void;
};

export default function ProfilePage({ onNavigate }: Props) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <AuthPage />;
  }

  return (
    <div className="min-h-screen bg-gray-50 pb-16">
      {onNavigate && (
        <div className="bg-white shadow-sm">
          <div className="max-w-7xl mx-auto px-4 py-4">
            <button
              onClick={() => onNavigate('home')}
              className="flex items-center text-gray-600 hover:text-gray-900"
            >
              <ArrowLeft className="h-5 w-5 mr-2" />
              Retour
            </button>
          </div>
        </div>
      )}
      <ProfileHeader />
      <div className="px-4 py-6 space-y-4">
        <ProfileForm
          onNavigateToDietAdmin={
            onNavigate ? () => {
              onNavigate('diet-admin');
            } : undefined
          }
          onNavigateToAdminPanel={
            onNavigate ? () => {
              onNavigate('admin-panel');
            } : undefined
          }
        />
      </div>
    </div>
  );
}